exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selecred-goods[data-v-3bee3264]  .el-dialog__body{height:75vh;overflow-y:auto}", ""]);

// exports
